module.exports = __webpack_public_path__ + "img/fo.b8d61ed7.svg";